import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import { AdminProvider } from "./context/AdminProvider";
import { AuthProvider } from "./context/AuthContext";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollManager from "./components/ScrollManager";
import PageWrapper from "./components/PageWrapper";
import PromoBar from "./components/PromoBar";
import Banner from "./components/Banner";
import Login from "./components/Login";
import PresenceProvider from "./components/PresenceProvider";

import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import Policies from "./pages/Policies";
import Booking from "./pages/Booking";
import NotFound from "./pages/NotFound";
import Admin from "./pages/Admin";
import Dashboard from "./pages/Dashboard";
import Protected from "./components/Protected";
import ProtectedAdmin from "./components/ProtectedAdmin";
import Signup from "./components/Signup";
import AdminUsers from "./pages/AdminUsers";
import AdminUserDetail from "./pages/AdminUserDetail";
import UserActivityLogsPage from "./pages/UserActivityLogPage";
import AdminBookings from "./pages/AdminBookings";
import AdminRevenue from "./pages/AdminRevenue";
import ActiveUsersPage from "./components/ActiveUsersPage";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrapper><Home /></PageWrapper>} />
        <Route path="/pricing" element={<PageWrapper><Pricing /></PageWrapper>} />
        <Route path="/booking" element={<PageWrapper><Booking /></PageWrapper>} />
        <Route path="/login" element={<PageWrapper><Login /></PageWrapper>} />
        <Route path="/contact" element={<PageWrapper><Contact /></PageWrapper>} />
        <Route path="/policies" element={<PageWrapper><Policies /></PageWrapper>} />
        <Route path="/terms" element={<PageWrapper><Terms /></PageWrapper>} />
        <Route path="/signup" element={<PageWrapper><Signup /></PageWrapper>} />
        <Route element={<Protected />}>
          <Route path="/dashboard" element={<PageWrapper><Dashboard /></PageWrapper>} />
        </Route>
        <Route element={<ProtectedAdmin />}>
          <Route path="/admin" element={<PageWrapper><Admin /></PageWrapper>} />
          <Route path="/admin/users" element={<PageWrapper><AdminUsers /></PageWrapper>} />
          <Route path="/admin/users/:userId" element={<PageWrapper><AdminUserDetail /></PageWrapper>} />
          <Route path="/admin/user-activity/:userId" element={<PageWrapper><UserActivityLogsPage /></PageWrapper>} />
          <Route path="/admin/bookings" element={<PageWrapper><AdminBookings /></PageWrapper>} />
          <Route path="/admin/revenue" element={<PageWrapper><AdminRevenue /></PageWrapper>} />
          <Route path="/admin/active-users" element={<PageWrapper><ActiveUsersPage /></PageWrapper>} />
        </Route>
        <Route path="*" element={<PageWrapper><NotFound /></PageWrapper>} />
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AdminProvider>
        <BrowserRouter>
          <PresenceProvider />
          <ScrollManager />
          <PromoBar />
          <div style={{ height: "var(--promo-h, 0px)" }} aria-hidden />
          <Header />
          <AnimatedRoutes />
          <Banner />
          <Footer />
        </BrowserRouter>
      </AdminProvider>
    </AuthProvider>
  );
}